import { connect } from "react-redux";
import SearchBar from "./upper/searchbar.component";
import styles from "../ui.module.scss";
import TopRightBubbles from "../actions/MapControls.component.jsx";
import InfoCard from "./bottom/poiCard.component.jsx";
import POICards from "./bottom/poicards.component";
import React, { useEffect, useRef, useState } from "react";
import ToastsContainer from "../../elements/toast/toasts.container";
import * as mainAction from "../../../reduxStore/actions/main.js";
import * as mainNavAction from "../../../reduxStore/actions/mainNav.js";
import * as searchAction from "../../../reduxStore/actions/search.js";
import * as actionInfo from "../../../reduxStore/actions/infoCard.js";
import * as mapActions from "../../../reduxStore/actions/map.js";
import * as actionRoute from "../../../reduxStore/actions/route";
import * as routeAction from "../../../reduxStore/actions/route";
import * as actionSettings from "../../../reduxStore/actions/settings";
import { isApp, pageNames } from "../../../reduxStore/reducers/main.js";
import { isMobile } from "react-device-detect";
import { GeneratedQRCode } from "../../elements/cards/GeneratedQRCode";
import { AppOverlay } from "../../../functions/classes/miscelleanous.classes.js";
import Search from "../../search/search.jsx";
import StandardCard from "../../elements/cards/StandardCard.card.jsx";
import DebuggerWindow from "../../elements/debugger/debugger.container.jsx";
import { setCurrentFloorNumber } from "../../../reduxStore/actions/floors.js";
import { addToast } from "../../../reduxStore/actions/toasts.js";
import { useCameraView } from "./mapInfo.sideEffects/useCameraView.sideEffects.js";
import { useShowPoiCards } from "./mapInfo.sideEffects/useShowPoiCards.sideEffects.js";
import { useHandleURLParams } from "./mapInfo.sideEffects/useHandleURLParams.sideEffects.js";
import { useHandleGoBack } from "./mapInfo.sideEffects/useHandleGoBack.sideEffects.js";
import { statisticLogger } from "../../statisticLogger/StatisticLogger.container";
import { terminalDualScreenPortion } from "../../../app/app.sideEffects/useURLParams.sideEffects";
import { useLayoutEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import StandardButton from "../../elements/buttons/standard.button";
import { nativeStorageInterface } from "../../..";
import Scanner from "../../../classes/Scanner";
import {
  CAMPUS_COLLECTION,
  MODULES,
} from "../../../reduxStore/actions/main.js";
import { cancelDataScanner } from "../../nativeAppInterface/NativeAppInterface";
import { center, points } from "@turf/turf";
import { startDataScanner } from "../../nativeAppInterface/NativeAppInterface";
import { POIS, MISC_INFO } from "../../../reduxStore/actions/main.js";
import StartDestination from "../../../functions/classes/startDestination.class";
import { vibrateDevice } from "../../nativeAppInterface/NativeAppInterface";
import { setRoute } from "../../../reduxStore/actions/route";
import { isInDevelopmentMode } from "../../../functions/helper/helpers.functions";
import { piKey } from "../../../app/app.sideEffects/useURLParams.sideEffects";
import { history } from "../../../reduxStore/store";
import { getQueryParams } from "../../../app/RouteWithSubRoutes";
import QrCodeReader from "../QrCodeReader/QrReader.component";
import QrScannerInfo from "./qrScannerInfo";
import DoorSignScannerInfo from "./doorSignScannerInfo";
import ScannerInfo from "../navigation/scannerInfo";
import { stableEaseTo } from "../mapbox/functions/interactivity.map";
import { map } from "../mapbox/map.sideEffects/useMap.sideEffects";

let scanListInfo = [];
let scanner = new Scanner();
function MapInfo(props) {
  const containerRef = useRef();
  // checkt ob von Außen die Applikation möchte, dass die Cards angezeigt werden
  const poiCardsCanShow = useShowPoiCards(props);

  const intl = useIntl();

  const [showPOICards, setShowPOICards] = useState(
    props.infoCardStatus === "close" && !(props.isFullMap || !props.mapLoaded)
  );

  const [showScannerInfo, setShowScannerInfo] = useState(false);
  const [qrOpen, setQrOpen] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const isFramed = !!urlParams.get("isFramed");

  const scanDoorSign =
    MISC_INFO.dataScanner.isAllowed &&
    isApp &&
    //currentLeg.isIndoor &&
    !isFramed &&
    piKey === "UKT-7wbrGmoTcGMsoSHnYvS10mCRTb76Ws1uolN3s5kdLJUj9M";

  const scanQrSign =
    isMobile &&
    MODULES.qrScannerAnbieten &&
    !isFramed &&
    (piKey === "KHBR-hXf0ATzBt5SCYTdNnY6c6Tm9z5AxhYMrpyKygpaZ3gbLo" ||
      piKey === "LHH-44sbHZhwah0o5cs7Go5QQSn2c89mR6VGImb9wT7N2smGUS");

  // console.log(
  //   "ICH LIOEBE ES datascanner ava ",
  //   props.dataScannerAvailable,
  //   "MISC:",
  //   MISC_INFO.dataScanner.isAllowed,
  //   "is in dev",
  //   isInDevelopmentMode(),
  //   "pikey true",
  //   piKey === "UKT-7wbrGmoTcGMsoSHnYvS10mCRTb76Ws1uolN3s5kdLJUj9M",
  //   piKey
  // );

  useHandleURLParams(props);
  useCameraView(props);
  useHandleGoBack(props);

  useEffect(() => {
    return () => {
      if (scanListInfo.length) {
        statisticLogger.addLog({
          action: {
            id: "keinBockaufnamenesfindung",
            group: "navigation",
            name: "whats scanned",
            movement: "stay",
            type: "click",
            interaction: "select",
            content: scanListInfo,
          },
        });

        scanListInfo = [];
      }

      window.foundedBuilding = null;
      window.foundedFloor = null;
    };
  }, []);

  const handleClickScanDoorSign = async () => {
    const seenScannerInfo = await nativeStorageInterface.get(
      "seen-scanner-info"
    );

    if (!seenScannerInfo) {
      setShowScannerInfo(true);
      nativeStorageInterface.set("seen-scanner-info", true);
    } else {
      setShowScannerInfo(false);
      if (scanner.scannedText.length) {
        scanner.clear();
      }
      startDataScanner(MISC_INFO.dataScanner.regEx);
      setTimeout(() => {
        if (piKey === "UKT-7wbrGmoTcGMsoSHnYvS10mCRTb76Ws1uolN3s5kdLJUj9M") {
          try {
            cancelDataScanner();
            //TODO abprüfen, ob kamera noch aktiv
            const room = scanner.getRoom();
            scanner.clear();

            // console.log("ALlle meine rooooooms", scanner.scannedText);

            if (room) {
              const vertices = CAMPUS_COLLECTION.getAllCampusNodes();

              const entrances = room.entrances.reduce((result, entry) => {
                const vertex = vertices.find((v) => v.id === entry.nodeId);
                if (!vertex) return result;

                result.push([vertex.coord[1], vertex.coord[0]]);
                return result;
              }, []);

              const c = center(points(entrances));

              // console.log("HALLLLLLLLOOOOOOOOOOO");

              history.push(
                `/${pageNames.map}/${pageNames.route}/${getQueryParams()}`
              );

              statisticLogger.addLog({
                action: {
                  group: "POICard",
                  movement: "leave",
                  type: "click",
                  interaction: "execute",
                  id: "routeToSelectedPOI",
                  name: "Route to selected POI",
                  content: {
                    globalPoiIds: [room.globalPoiId],
                    globalPoiId: room.globalPoiId,
                    globalName: room.name,
                  },
                },
              });

              // props.setStart(
              //   StartDestination.createStartDestination(
              //     843437,
              //     intl.formatMessage({ id: "gps.selectedPlace" })
              //   )
              // );

              setTimeout(() => {
                props.setStart(
                  new StartDestination({
                    isSet: true,
                    lat: c.geometry.coordinates[1],
                    lng: c.geometry.coordinates[0],
                    level: room.level,
                    positionType: "user",
                    name: intl.formatMessage({ id: "gps.doorSign" }),
                  })
                );

                if (props.destination && props.destination.lat !== 0) return;

                setTimeout(() => {
                  stableEaseTo({
                    center: [
                      c.geometry.coordinates[0],
                      c.geometry.coordinates[1],
                    ],
                    duration: 1500,
                  });
                  map.zoomTo(23, { duration: 1000 });
                }, 500);
              }, 100);

              vibrateDevice();
            } else {
              window.addLog({
                show: true,
                upload: false,
                userMessage: "scanner.roomNotFound",
              });
            }
          } catch (e) {
            cancelDataScanner();
            window.addLog({
              show: true,
              upload: false,
              userMessage: "scanner.error",
            });
            throw e;
          }
        }
      }, 5000);
    }
  };

  const handleClickQcSign = async () => {
    console.log("tesadsad");
    setQrOpen(true);
  };

  useEffect(() => {
    props.setMapPage(pageNames.info);

    statisticLogger.currentPage = pageNames.info;
    statisticLogger.addLog({
      action: {
        id: "enterMapInfoPage",
        name: "Enter MapInfo Page",
        group: "Page",
        movement: "enter",
        type: "click",
      },
    });
  }, []);
  useLayoutEffect(() => {
    props.setMapPadding({ left: containerRef.current.clientWidth + 100 }, true);
  }, []);

  useEffect(() => {
    // Effekt checkt ab, ob die Cards wieder angezeigt werden sollen
    // sieht auf den ersten Blick komisch aus, aber setShowPOICards darf an dieser Stelle nur auf true gesetzt werden
    // auf false darf es nur von den POICards selbst gesetzt werden, wenn diese mit ihrer Animation done sind
    if (poiCardsCanShow) setShowPOICards(true);
  }, [props.infoCardStatus, props.isFullMap, props.mapLoaded]);

  window.didScanText = (text) => {
    if (piKey === "UKT-7wbrGmoTcGMsoSHnYvS10mCRTb76Ws1uolN3s5kdLJUj9M") {
      scanListInfo.push(text);
      scanner.addText(text);

      return;
    }
  };

  const onReadId = async (result) => {
    const qrCode = await result;

    let start = false;

    const hasStart = !!qrCode.startNodeId;
    const hasDestination = !!qrCode.destinationId;

    if (hasStart) {
      history.push(`/${pageNames.map}/${pageNames.route}/${getQueryParams()}`);

      setTimeout(() => {
        const currentVertex = CAMPUS_COLLECTION.getCurrentCampus().nodes.find(
          (v) => v.id === qrCode.startNodeId
        );

        start = new StartDestination({
          nodeId: null,
          poiId: null,
          isSet: true,
          lat: currentVertex.coord[0],
          lng: currentVertex.coord[1],
          level: currentVertex.coord[2],
          name: intl.formatMessage({ id: "gps.selectedPlace" }),
          campusId: null,
          address: null,
        });
        start.globalPoiId = null;
        props.setStart(start);
      }, 100);
    }

    if (hasDestination) {
      let poi = POIS.all.find((p) => p.globalPoiId === qrCode.destinationId);

      const destination = new StartDestination({
        nodeId: null,
        poiId: poi.globalPoiId,
        isSet: true,
        lat: poi.position.lat,
        lng: poi.position.lng,
        level: poi.position.z,
        name: poi.name,
        campusId: null,
        address: null,
      });

      if (!hasStart) {
        props.setCurrentFeature(destination);
        props.setPreOpen(true);
      } else {
        setTimeout(() => {
          props.setTarget(destination);
        }, 100);
      }
    }

    vibrateDevice();
  };

  return (
    <>
      <div className={`${styles.upperBlock}`} style={{ transition: "1s" }}>
        <div
          ref={containerRef}
          className={`${styles.upperBar} general-margin-horizontally d-flex flex-column`}
        >
          {!(
            props.currentAppOverlay.name === AppOverlay.names.search &&
            !isMobile
          ) &&
            terminalDualScreenPortion === 0 && <SearchBar {...props} />}
          <ToastsContainer />
          <DebuggerWindow />
          <DesktopInfoCard {...props} />
        </div>
        <TopRightBubbles
          setMapStyle={props.setMapStyle}
          setUseSound={props.setUseSound}
          useSound={props.useSound}
          isApp={props.isApp}
        />
      </div>
      {scanDoorSign ? (
        <DoorSignScannerInfo onClick={handleClickScanDoorSign} />
      ) : scanQrSign ? (
        <QrScannerInfo onClick={handleClickQcSign} />
      ) : null}
      <ScannerInfo show={showScannerInfo} onClose={handleClickScanDoorSign} />
      {showPOICards ? (
        <div
          className={`pointer-event-off show-poi-cards-container ${styles.ui}`}
        >
          <POICards
            onClosingEnd={() => setShowPOICards(false)}
            mapLoaded={props.mapLoaded}
            supposedToShow={poiCardsCanShow}
            currentFeature={props.currentFeature}
            setCurrentFeature={props.setCurrentFeature}
            setPreOpen={props.setPreOpen}
            currentChildrenPOIs={props.currentChildrenPOIs}
            currentCampusId={props.currentCampusId}
            currentAppOverlay={props.currentAppOverlay}
            mapBounds={props.mapBounds}
          />
        </div>
      ) : null}
      {props.infoCardStatus !== "close" && isMobile ? (
        <InfoCard renderInDragContainer={true} />
      ) : null}
      {qrOpen ? (
        <QrCodeReader
          history={history}
          readId={onReadId}
          canceled={() => setQrOpen(false)}
        />
      ) : null}
    </>
  );
}

/**
 * InfoCard, QRCodeCard, SearchCard für die Desktop/Terminal Variante
 * @param props
 * @return {JSX.Element|null}
 * @constructor
 */
function DesktopInfoCard(props) {
  if (props.currentAppOverlay.name === AppOverlay.names.search && !isMobile) {
    return (
      <StandardCard
        padding={false}
        className={`mb-3 pt-3 h-100 max-width-40 shadow-1 position-relative`}
      >
        <Search
          type={props.type}
          onClose={props.currentAppOverlay.onClose}
          mustHaveLocation={props.currentAppOverlay.mustHaveLocation}
          onPOIClicked={props.currentAppOverlay.onPOIClicked}
          canSetCurrentPosition={props.currentAppOverlay.canSetCurrentPosition}
          canSetPositionOnMap={props.currentAppOverlay.canSetPositionOnMap}
          onSpecialLocationClicked={
            props.currentAppOverlay.onSpecialLocationClicked
          }
        />
      </StandardCard>
    );
  } else if (props.infoCardStatus !== "close" && !isMobile) {
    return (
      <InfoCard
        className={`mt-3 mb-3 max-width-30 shadow-1`}
        renderInDragContainer={false}
      />
    );
  } else if (props.isTerminal) {
    return (
      <GeneratedQRCode
        qrCodeHeight={7}
        className={`mt-3 max-width-30 shadow-1`}
        isTerminal={props.isTerminal}
      />
    );
  } else return null;
}

const mapStateToProps = (state) => {
  return {
    mapLoaded: state.map.mapLoaded,
    defaultAngle: state.settings.mapAngle.angle,
    isApp: state.main.isApp,
    isTerminal: state.main.isTerminal,
    terminalIsIdle: state.main.terminalIsIdle,
    useSound: state.settings.useSound,
    currentFeature: state.main.currentFeature,
    currentChildrenFather: state.main.currentChildrenFather,
    currentChildrenPOIs: state.main.currentChildrenPOIs,
    infoCardStatus: state.infoCard.status,
    isFullMap: state.main.isFullMap,
    mapBounds: state.map.bounds,
    currentFloorIndex: state.floors.currentFloorIndex,
    currentCampusId: state.main.currentCampusId,
    mainMenuStatus: state.mainMenu.status,
    currentAppOverlay: state.main.currentAppOverlay,
    terminalBearing: state.map.terminalBearing,
    defaultStartNode: state.route.defaultStartNode,
    dataScannerAvailable: state.main.dataScannerAvailable,
    needAudio: state.settings.useSound,
    currentRoute: state.route.currentRoute,
    navigationMode: state.route.navigationMode,
    liveNavigationInformation: state.route.liveNavigationInformation,
    mapPadding: state.map.mapPadding,
    locationSettings: state.settings.location,
    locationObject: state.route.locationObject,
    centerLat: state.map.lat,
    centerLng: state.map.lng,
    target: state.route.target,
    start: state.route.start,
    routeErrorCounter: state.route.routeErrorCounter,
    routingSettings: state.settings.routing,
    roadUserType: state.route.roadUserType,
    goToParkingSpot: state.route.goToParkingSpot,
    language: state.main.language,
    deviceInformation: state.main.deviceInformation,
    destination: state.route.target,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page) => dispatch(mainAction.setPage(page)),
    setMapPage: (page) => dispatch(mapActions.setPage(page)),
    closeInfoCard: () => dispatch(actionInfo.setClose()),
    openMainNav: () => dispatch(mainNavAction.setOpen()),
    closeMainNav: () => dispatch(mainNavAction.setClose()),
    setSearchCategory: (category) =>
      dispatch(searchAction.setSearchCategory(category)),
    setSearchTarget: (type) => dispatch(searchAction.setTarget(type)),
    setCurrentFeature: (feature) =>
      dispatch(mainAction.setCurrentFeature(feature)),
    setStatus: (status) => dispatch(actionInfo.setStatus(status)),
    setPreOpen: () => dispatch(actionInfo.setPreOpen()),
    setMapStyle: () => dispatch(mapActions.toggleMapStyle()),
    toggle3DBuildings: () => dispatch(mapActions.toggle3DBuildings()),
    toggleIsFullMap: (value) => dispatch(mainAction.toggleIsFullMap(value)),
    setStart: (feature) => dispatch(actionRoute.setStart(feature)),
    setCurrentFloorNumber: (number) => dispatch(setCurrentFloorNumber(number)),
    setTarget: (feature) => dispatch(actionRoute.setTarget(feature)),
    addToast: (toast) => dispatch(addToast(toast)),
    setFetchNewRoute: (status) =>
      dispatch(routeAction.setFetchNewRoute(status)),
    setUseSound: (useSound) =>
      dispatch(actionSettings.setProperties({ useSound })),
    setCurrentAppOverlay: (object) =>
      dispatch(mainAction.setCurrentAppOverlay(object)),
    mapURLParamsHandled: () => dispatch(actionRoute.mapURLParamsHandled()),
    setMapPadding: (padding, tellMap) =>
      dispatch(mapActions.setMapPadding(padding, tellMap)),
    setRoute: (
      start,
      target,
      settings,
      type,
      goToParkingSpot,
      language,
      deviceInformation,
      isApp,
      isTerminal
    ) =>
      dispatch(
        actionRoute.setRoute(
          start,
          target,
          settings,
          type,
          goToParkingSpot,
          language,
          deviceInformation,
          isApp,
          isTerminal
        )
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MapInfo);
